import QueryString from 'query-string';

import { onlyTheseKeys, removeTheseKeys, removeFalsy } from '../../../util/params';
import { HISTORY_QUERY_KEYS, API_KEYS } from './constants';
import { formatFromDateToWhatsOnAPI, formatFromHistoryToDate, formatFromDateToHistory } from '../../../util/date';

export default null;


export const stringifyParams = params => Object.keys(params).reduce((str, paramKey) => (`${str}&${paramKey}=${params[paramKey]}`), '?');


export const parseRadiusOptions = (radiusOptions, radiusPlaceholder) => {
  const updatedOptions = Object.keys(radiusOptions).map(key => ({
    value: String(key),
    label: radiusOptions[key],
  }));

  updatedOptions.unshift({
    value: '0',
    label: radiusPlaceholder,
  });

  return updatedOptions;
};


export const updateHistoryString = (state, radiusCheck) => {
  // check and update state to apply default location radius if needed
  // (i.e. user has entered a location and no radius)
  const stateWithDefaultLocationRadiusCheck = {
    ...state,
    radiusKm: radiusCheck,
  };

  // purify state params
  const params = onlyTheseKeys(stateWithDefaultLocationRadiusCheck, HISTORY_QUERY_KEYS);

  // acquire search params
  let searchParams = QueryString.parse(window.location.search);
  // cast page
  if (searchParams.page && typeof searchParams.page === 'string') {
    searchParams.page = parseInt(searchParams.page, 10) - 1;
  }
  // cast radiusKm
  if (searchParams.radiusKm && typeof searchParams.radiusKm === 'string') {
    searchParams.radiusKm = parseInt(searchParams.radiusKm, 10);
  }
  // purify search params
  searchParams = onlyTheseKeys(searchParams, HISTORY_QUERY_KEYS);

  searchParams = {
    ...searchParams,
    ...params,
  };

  searchParams = removeTheseKeys(searchParams, [
    'parentItemId',
    'pageSize',
  ]);

  // a single parsed tag will be a string and not an array, so convert,
  // I'm actually not sure this code will ever run, as it should already be in an array
  if (typeof searchParams.tags === 'string') {
    searchParams.tags = [searchParams.tags];
  }

  if (searchParams.startDate instanceof Date) {
    searchParams.startDate = formatFromDateToHistory(searchParams.startDate);
  }

  if (searchParams.endDate instanceof Date) {
    searchParams.endDate = formatFromDateToHistory(searchParams.endDate);
  }

  searchParams = removeFalsy(searchParams);

  if (searchParams.page === 0) {
    delete searchParams.page;
  } else if (searchParams.page > 0) {
    // if page index in params exists, convert base in 1 based page number
    searchParams.page += 1;
  }

  const search = `?${QueryString.stringify(searchParams, { arrayFormat: 'comma' })}`;
  let url;
  if (search.length > 1) {
    url = `${window.location.pathname}${search}`;
  } else {
    url = window.location.pathname;
  }

  // check if push state needs to happen
  if (window.location.search !== search) {
    window.history.pushState(null, null, url);
  }
};


export const getParamsFromQueryString = () => {
  let searchParams = QueryString.parse(window.location.search);

  if (searchParams.page && typeof searchParams.page === 'string') {
    // if page from query exists, convert to an int zero based index
    searchParams.page = parseInt(searchParams.page, 10) - 1;
  }

  if (typeof searchParams.tags === 'string') {
    searchParams.tags = [searchParams.tags];
  }

  searchParams = onlyTheseKeys(searchParams, HISTORY_QUERY_KEYS);

  searchParams.excludePlaceOfInterest = searchParams.excludePlaceOfInterest === 'true' ? true : null;

  if (typeof searchParams.startDate === 'string') {
    searchParams.startDate = new Date(formatFromHistoryToDate(searchParams.startDate));
  }

  if (typeof searchParams.endDate === 'string') {
    searchParams.endDate = new Date(formatFromHistoryToDate(searchParams.endDate));
  }

  return searchParams;
};


export const compileApiQuery = (state, globals) => {
  const extractParamsFromState = onlyTheseKeys(state, API_KEYS);
  const extractParamsFromGlobals = onlyTheseKeys(globals.globals, API_KEYS);

  let mergedState = {
    ...extractParamsFromState,
    ...extractParamsFromGlobals,
  };

  if (mergedState.startDate instanceof Date) {
    mergedState.startDate = formatFromDateToWhatsOnAPI(mergedState.startDate);
  }

  if (mergedState.endDate instanceof Date) {
    mergedState.endDate = formatFromDateToWhatsOnAPI(mergedState.endDate);
  }

  // remove all other nulls
  mergedState = removeFalsy(mergedState);

  return `${globals.globals.api}?${QueryString.stringify(mergedState)}`;
};
